import { render } from "./VoiceCall.vue?vue&type=template&id=3e125cce&scoped=true"
import script from "./VoiceCall.vue?vue&type=script&lang=js"
export * from "./VoiceCall.vue?vue&type=script&lang=js"

import "./VoiceCall.vue?vue&type=style&index=0&id=3e125cce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e125cce"]])

export default __exports__